import { Card, Col, Container, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHandHoldingHeart,
  faLeaf,
  faSeedling,
  faTree,
  type IconDefinition,
} from '@fortawesome/free-solid-svg-icons';

import './Greenary.css';

interface FeatureItem {
  icon: IconDefinition;
  title: string;
  description: string;
}

const greeneryFeatures: FeatureItem[] = [
  {
    icon: faTree,
    title: 'Abundant Trees',
    description:
      'Home to numerous tree species providing natural shade and fresh air',
  },
  {
    icon: faLeaf,
    title: 'Landscaping',
    description:
      'Professionally maintained gardens and landscapes throughout the community',
  },
  {
    icon: faSeedling,
    title: 'Plant Nursery',
    description: 'Dedicated nursery for growing and nurturing new plants',
  },
  {
    icon: faHandHoldingHeart,
    title: 'Dedicated Care',
    description:
      'Expert maintenance staff ensuring the health of our green spaces',
  },
];

const Greenary = () => {
  return (
    <section className="greenary-section">
      <Container>
        <div className="section-header mb-4">
          <h3 className="initiative-title">
            <FontAwesomeIcon icon={faLeaf} className="me-2" />
            Our Green Initiative
          </h3>
          <p className="section-description">
            Aparna Western Meadows takes pride in being one of the greenest
            communities, with an extensive collection of trees and plants
            maintained by our dedicated staff.
          </p>
        </div>

        <Row className="g-4">
          {greeneryFeatures.map((feature, index) => (
            <Col key={index} xs={12} md={6} lg={3}>
              <Card className="greenary-card h-100">
                <Card.Body className="text-center">
                  <div className="feature-icon-wrapper mb-3">
                    <FontAwesomeIcon
                      icon={feature.icon}
                      className="feature-icon"
                    />
                  </div>
                  <Card.Title className="feature-title">
                    {feature.title}
                  </Card.Title>
                  <Card.Text className="feature-description">
                    {feature.description}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Greenary;
